/**
 * Priority values mirror the `Visit.priority` enum. ASSUMPTION (contract status: draft):
 * confirmed by task-03.
 */
export const VisitPriority = {
    NORMAL: 'normal',
    HIGH: 'high'
};
/**
 * Unit in which `duration` is posted. ASSUMPTION (contract status: draft): minutes,
 * matching `#duration_hidden_field` on the show page add-visit modal.
 */
export const DURATION_UNIT_MINUTES = 'minutes';
